// extracted by mini-css-extract-plugin
module.exports = {"desktop":"min-width: 75em","monitor":"min-width: 97.5rem","mainStackGap":"var(--mainStackGap)","green":"#00b047","app":"app_app__EUP_S"};